import { useEffect, useMemo } from 'react';

import type { IThemeContext } from './context';
import { useConfig } from '~/hooks';
import { ThemeContext } from './context';

type Props = React.PropsWithChildren;

export const ThemeProvider = (props: Props) => {
  const { children } = props;
  const config = useConfig();

  const contextValue = useMemo<IThemeContext | null>(() => {
    return config.theme;
  }, [config.theme]);

  useEffect(() => {
    const style = document.getElementById('_fonts');
    if (!style) return;

    style.appendChild(
      document.createTextNode(
        Object.values(config.theme.typography.fonts).reduce((acc, current) => {
          return acc + current + '\n';
        }, '')
      )
    );
  }, [config.theme]);

  return <ThemeContext value={contextValue}>{children}</ThemeContext>;
};
